import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { NavChild } from './nav-config';

@Component({
  selector: 'sh-nav-dropdown',
  imports: [RouterLink, RouterLinkActive, LucideAngularModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="dropdown-panel" role="menu">
      @for (child of items(); track child.id) {
        <a
          class="dropdown-item"
          role="menuitem"
          [routerLink]="child.route"
          routerLinkActive="dropdown-item--active"
          [routerLinkActiveOptions]="{ exact: child.route === items()[0]?.route }"
          (click)="itemSelected.emit(child.route)">
          <lucide-angular [img]="child.icon" [size]="14" class="dropdown-item__icon"></lucide-angular>
          <span>{{ child.label }}</span>
        </a>
      }
    </div>
  `,
  styles: [`
    :host {
      display: block;
      position: absolute;
      top: calc(100% + 6px);
      left: 50%;
      transform: translateX(-50%);
      z-index: 50;
      animation: dropdownIn 150ms ease-out;
    }

    .dropdown-panel {
      min-width: 180px;
      padding: 6px;
      border-radius: 12px;
      background: var(--color-surface-container);
      border: 1px solid var(--color-surface-border);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.06);
    }

    .dropdown-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 12px;
      border-radius: 8px;
      font-size: 0.8125rem;
      font-weight: 500;
      color: var(--color-text-primary);
      text-decoration: none;
      transition: background-color 150ms ease, color 150ms ease;
      cursor: pointer;
      white-space: nowrap;
    }

    .dropdown-item:hover {
      background: var(--color-surface-hover);
      color: var(--color-text-secondary);
    }

    .dropdown-item--active {
      background: var(--color-surface-selected);
      color: var(--color-text-on-brand);
      font-weight: 600;
    }

    .dropdown-item--active:hover {
      background: var(--color-surface-selected);
      color: var(--color-text-on-brand);
    }

    .dropdown-item__icon {
      opacity: 0.7;
      flex-shrink: 0;
    }

    .dropdown-item--active .dropdown-item__icon {
      opacity: 1;
    }

    @keyframes dropdownIn {
      from {
        opacity: 0;
        transform: translateX(-50%) translateY(-4px);
      }
      to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
      }
    }
  `],
})
export class NavDropdownComponent {
  readonly items = input.required<NavChild[]>();
  readonly itemSelected = output<string>();
}
